import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const AuthChoice = () => {
  const [params] = useSearchParams();
  const benefitId = params.get("benefit");
  const navigate = useNavigate();

  return (
    <div className="container text-center mt-5">
      <h3>Para continuar, iniciá sesión o registrate</h3>
      <p>Estás por reclamar el beneficio #{benefitId}</p>
      <div className="d-flex justify-content-center gap-3 mt-4">
        <Button onClick={() => navigate(`/login?benefit=${benefitId}`)}>
          Iniciar sesión
        </Button>
        <Button variant="outline-primary" onClick={() => navigate(`/register?benefit=${benefitId}`)}>
          Registrarme
        </Button>
      </div>
    </div>
  );
};

export default AuthChoice;
